import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Button } from "../../../Button";
import { themes } from "../../../Button/constants";
import { Field } from "./..";
import { datesArrayToDateString } from "../../helpers";
import DateRangePicker from "../../../DateMonthPicker/components/DateRangePicker";
import Datepicker from "../../../Datepicker";
import { Calendar } from "../../../icons";
import { ButtonBase } from "../../../internal/ButtonBase";
import { ClickOutside } from "../../../internal/ClickOutside";
import styles from './DatePick.css';
var cx = classNames.bind(styles);
var defaultValues = {
  withRange: ['', ''],
  withoutRange: ''
};
export var DatePick = function DatePick(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      withRange = _ref.withRange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      pickerValue = _useState4[0],
      setPickerValue = _useState4[1];

  var defaultValue = withRange ? defaultValues.withRange : defaultValues.withoutRange;
  useEffect(function () {
    if (value) {
      setPickerValue(value);
    } else {
      setPickerValue(defaultValue);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  var toggleRef = useRef();
  var prepend = /*#__PURE__*/React.createElement(Calendar, {
    color: "N300"
  });

  var handleToggle = function handleToggle() {
    setIsOpen(function (prevState) {
      return !prevState;
    });
  };

  var handleClose = function handleClose() {
    setIsOpen(false);
  };

  var handleChangeValue = function handleChangeValue(date) {
    setPickerValue(date);
  };

  var handleAccept = function handleAccept() {
    onChange(pickerValue);
    handleClose();
  };

  var handleFieldChange = function handleFieldChange(event) {
    onChange(event);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement(ButtonBase, {
    className: cx('control'),
    ref: toggleRef,
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement(Field, {
    placeholder: name,
    prepend: prepend,
    value: datesArrayToDateString(value),
    onChange: function onChange(e) {
      return handleFieldChange(e);
    },
    focused: isOpen,
    disabled: true
  })), /*#__PURE__*/React.createElement(ClickOutside, {
    ignoreRefs: [toggleRef],
    onClickOutside: handleClose,
    className: cx('picker', {
      opened: isOpen
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('picker-body')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('picker-item')
  }, !withRange && /*#__PURE__*/React.createElement(Datepicker, {
    value: pickerValue || defaultValue,
    onChange: handleChangeValue,
    classes: {
      root: cx('datepicker-override')
    },
    block: true,
    selectable: true,
    navbarType: "unbordered"
  }), withRange && /*#__PURE__*/React.createElement(DateRangePicker, {
    value: pickerValue,
    onChange: handleChangeValue
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('picker-item')
  }, /*#__PURE__*/React.createElement(Button, {
    theme: themes.b2c,
    onClick: handleAccept,
    block: true
  }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C")))));
};